import { useNavigate } from 'react-router-dom';
import '../styles/ItemSelection.css';

const ItemSelection = ({ 
  tier, 
  items, 
  selectedItems = [], 
  currentStep,
  maxSelections = 1 
}) => {
  const navigate = useNavigate();

  const availableItems = items.filter(item => 
    !selectedItems.some(selected => selected?.id === item.id)
  );

  const handleItemClick = (item) => {
    navigate(`/item/${item.id}`, {
      state: {
        item: {
          ...item,
          tier
        },
        currentStep,
        maxSelections,
        currentSelections: selectedItems
      }
    });
  };

  return (
    <div className={`item-selection ${tier}`}>
      <h3>{tier === 'tier1' ? 'Standard Items' : 'Premium Items'}</h3>
      <p className="selection-info">
        {maxSelections > 1 ? 
          `Select up to ${maxSelections} items` : 
          'Select 1 item'}
        {selectedItems.length > 0 && (
          <span className="selection-count">
            ({selectedItems.length}/{maxSelections} selected)
          </span>
        )}
      </p>
      
      <div className="items-grid">
        {availableItems.map(item => (
          <div
            key={item.id}
            className="item-card"
            onClick={() => handleItemClick(item)}
          >
            <div className="item-image">
              {item.image ? (
                <img src={item.image} alt={item.name} />
              ) : (
                <div className="placeholder-image">
                  {item.name?.charAt(0) || 'I'}
                </div>
              )}
            </div>
            <div className="item-info">
              <h4>{item.name}</h4>
              <p>${item.price?.toFixed(2)}</p>
              {tier === 'tier2' && <span className="premium-badge">Premium</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ItemSelection;